// extracted by mini-css-extract-plugin
export var accountPageStructure = "account-page-structure_TBakNPiXE38kJ5m0y6sx";
export var accountPageStructureMain = "account-page-structure__main_Fc8Wkx1B20PGoLaICL32";
export var accountPageStructureSidebar = "account-page-structure__sidebar_ETAXgX6ElSRvjq1yeHPG";
export var accountPageStructureWrapper = "account-page-structure__wrapper_FTjyQFo_4WTGhBgyeI5d";